var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCancelled = function SvgCancelled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19,
    viewBox: "-5 -5 30 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.38.432a.707.707 0 0 1 .015 1.01l-.014.015L11.059 9.5l8.322 8.043a.707.707 0 0 1 0 1.025.77.77 0 0 1-1.045.014l-.015-.014L10 10.524l-8.32 8.044a.77.77 0 0 1-1.06 0 .707.707 0 0 1-.015-1.01l.014-.015L8.94 9.5.62 1.457a.707.707 0 0 1 0-1.025.77.77 0 0 1 1.044-.014l.015.014L10 8.475 18.32.432a.77.77 0 0 1 1.06 0"
  })));
};
export default SvgCancelled;